
export default {
  name: 'TransactionPendingToast',
  props: {
    msg: { type: String, default: 'Transaction pending...' },
  },
};
